import React, { useState } from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Input, MenuList, MenuItem, ListItemText } from "@material-ui/core";
import { useLocalizedName } from "../../globals/langHelpers";

const useStyles = makeStyles((theme) => ({
    container: {
        border: "1px solid #00549a",
        borderRadius: "2px",
        boxSizing: "border-box",
        padding: "16px",
    },
    picker: {
        height: "245px",
        overflowY: "scroll",
    },
    listItem: {
        border: "1px solid var(--text-medium)",
        margin: "8px 0px",
        borderRadius: "4px",
    },
    listItemActive: {
        border: "1px solid var(--blue-bell)",
    },
}));

const messages = defineMessages({
    searchReasons: {
        id: "task-incomplete-form.search-reason",
        defaultMessage: "Search for a reason…",
        description: "Search for a reason…",
    },
});

export const FormSelect = ({ onChange, options, onSelect, existingValue = null }) => {
    const intl = useIntl();
    const classes = useStyles();
    const { getLocalizedName } = useLocalizedName();
    const [value, setValue] = React.useState(existingValue);
    const [search, setSearch] = useState("");

    const onItemClick = (event, option) => {
        setValue(option);
        onSelect(option);
        if (onChange) onChange(event, option);
    };

    const handleSearch = (event) => {
        setSearch(event.target.value.toString());
    };

    return (
        <div className={classes.container}>
            <Input fullWidth placeholder={intl.formatMessage(messages.searchReasons)} value={search} type="search" onChange={handleSearch} />
            <MenuList className={"bell-scrollbar " + classes.picker}>
                {options
                    .filter((opt) => getLocalizedName({ object: opt }).toLowerCase().includes(search.toLowerCase()))
                    .map((option, index) => (
                        <MenuItem
                            style={{ whiteSpace: "normal" }}
                            key={option.id}
                            value={getLocalizedName({ object: option })}
                            disableGutters
                            onClick={(event) => onItemClick(event, option)}
                            selected={value === option}>
                            <ListItemText disableTypography primary={getLocalizedName({ object: option })} />
                        </MenuItem>
                    ))}
            </MenuList>
        </div>
    );
};

export default FormSelect;
